import {FILENAME_UNSAFE} from './constants';
import {ResultsViewProps} from '.';

const todayDateSegment = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const pdfFilenameFor = (firstName?: string): string => {
  const slug = (firstName ?? '')
    .trim()
    .toLowerCase()
    .replace(FILENAME_UNSAFE, '-')
    .replace(/^-+|-+$/g, '');
  const parts = ['financial-health-score', slug, todayDateSegment()].filter(
    Boolean,
  );

  return `${parts.join('-')}.pdf`;
};

export const downloadPdf = async (props: ResultsViewProps): Promise<void> => {
  /*
   * @react-pdf/renderer and the whole PdfReport tree load here rather than at
   * module scope. This is the only path that reaches them, and it runs on a
   * user action, so keeping them static shipped a PDF renderer to every visitor
   * of the results step whether or not they ever downloaded anything.
   */
  const [{pdf}, {default: FinancialHealthScorePdf}] = await Promise.all([
    import('@react-pdf/renderer'),
    import('../PdfReport'),
  ]);

  const blob = await pdf(<FinancialHealthScorePdf {...props} />).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = pdfFilenameFor(props.firstName);
  document.body.appendChild(link);

  try {
    link.click();
  } finally {
    link.remove();
    // Defer the revoke so the browser has time to start the download
    // before the blob URL is invalidated. Revoking on the same tick as
    // click() can cancel the download on mobile browsers.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
};
